import en from './en';
import ja from './jp';

const languages = {
  en,
  ja
}

export default languages;